var render = function render(){var _vm=this,_c=_vm._self._c;return _c('icon-switch',{staticClass:"image-toggle",attrs:{"value":_vm.showImage},on:{"input":_vm.toggleImage}},[_vm._v(" 🖼️ ")])
}
var staticRenderFns = []

export { render, staticRenderFns }